import app from "../_app";

const headings = [...document.querySelectorAll('.js-collapse-heading')];
const footerHeadings = [...document.querySelectorAll('.js-collapse-heading-footer')];

if(app.viewport.isSmallerThan('lg')) {
    footerHeadings.map(heading => heading.addEventListener('click', () => {
        if (heading.hasAttribute('data-open')) {
            heading.nextElementSibling.style.height = 0;
            heading.removeAttribute('data-open');
        } else {
            heading.setAttribute('data-open', '');
            heading.nextElementSibling.style.height = `${heading.nextElementSibling.scrollHeight}px`;
        }
    }));
}

headings.map(heading => heading.addEventListener('click', () => {
    if (heading.hasAttribute('data-open')) {
        heading.nextElementSibling.style.height = 0;
        heading.removeAttribute('data-open');
    } else {
        heading.setAttribute('data-open', '');
        heading.nextElementSibling.style.height = `${heading.nextElementSibling.scrollHeight}px`;
    }
}));

